module.exports = __webpack_public_path__ + "img/verify-background.ed583cf7.jpg";